import { Heading, TextPassage } from '@petsmart-ui/sparky';
import { useFieldArray, useFormContext } from 'react-hook-form';

import type { FormFields } from '@/entities/purchase-form';

import { Input } from './Input';

type InputLinesProps = {
    name: 'frontLines' | 'backLines';
};

export const InputLines = ({ name }: InputLinesProps) => {
    const { control } = useFormContext<FormFields>();
    const { fields } = useFieldArray({ control, name: `personalization.${name}` });

    if (!fields.length) {
        return null;
    }

    return (
        <div className="personalization-drawer__section">
            <div className="personalization-drawer__section-header">
                <Heading tagName="h2" size="body-lg-bold" className="personalization-drawer__heading">
                    {name === 'frontLines' ? 'Front' : 'Back'}
                </Heading>

                <TextPassage className="personalization-drawer__subtitle">
                    You can add up to {fields.length} lines of text on the {name === 'frontLines' ? 'front' : 'back'}.
                </TextPassage>
            </div>

            <div className="personalization-drawer__section-body">
                {fields.map((field, index) => {
                    return (
                        <Input
                            name={name}
                            index={index}
                            max={field.max}
                            key={field.order}
                            isRequired={field.required}
                        />
                    );
                })}
            </div>
        </div>
    );
};
